import { render, staticRenderFns } from "./PaywallPlanMini.vue?vue&type=template&id=4a8904d1&scoped=true&"
import script from "./PaywallPlanMini.vue?vue&type=script&lang=ts&"
export * from "./PaywallPlanMini.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallPlanMini.vue?vue&type=style&index=0&id=4a8904d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8904d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4a8904d1', component.options)
    } else {
      api.reload('4a8904d1', component.options)
    }
    module.hot.accept("./PaywallPlanMini.vue?vue&type=template&id=4a8904d1&scoped=true&", function () {
      api.rerender('4a8904d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/PaywallPlanMini.vue"
export default component.exports